import jQuery from "jquery";

window.$ = window.jQuery = jQuery


// WEBPACK FOOTER //
// ./src/common/template/jquery.js